import "./CostSummaryCostTable.css";

import { useDispatch, useSelector } from "react-redux";

import Table from "components/Table/Table";
import { getCostSummaryCostData } from "slices/costSummary/costSummarySelectors";
import { costSummaryActions } from "slices/costSummary/costSummarySlice";

import CostSummaryCostTableColumns from "./CostSummaryCostTableColumns";

const CostSummaryCostTable = () => {
	const dispatch = useDispatch();
	const tableData = useSelector(getCostSummaryCostData);
	const columnsData = CostSummaryCostTableColumns();

	return (
		<div className="CostSummaryCostTable">
			<div className="CostSummaryTableTitle">Таблица 1</div>
			<Table
				rowData={tableData}
				columnsData={columnsData}
				scrollBlock={null}
				options={{
					selectOptions: {
						controlled: true,
						uncontrolled: false,
						multiple: false,
					},
					displayOptions: {
						rowsDisplayCount: 100,
						columnsWithMinWidth: [{ name: "name", minWidth: "200px" }],
					},
				}}
				funcs={{
					setTableData: ({ newTableData }) => dispatch(costSummaryActions.setCostData(newTableData)),
				}}
			/>
		</div>
	);
};

export default CostSummaryCostTable;
